import React from "react";

const NoImageArea = () => {
  return (
    <div className="image-area noimage">
      <p>No Img</p>
    </div>
  );
};

export default NoImageArea;
